export default __webpack_public_path__ + "188208ca3c63a80c0601aee816192e4c.webp";